export enum AbTypeCode {
  A = "A",
  B = "B",
}